import Provider from "./enum/Provider.enum";
import Role from "./enum/Role.enum";

const routesConfig = [
  {
    path: "/agents",
    label: "Агенты",
    componentPath: "Agents",
    requiredRoles: [Role.AGENT_ADMIN],
  },
  {
    path: "/rates",
    label: "Схемы",
    componentPath: "Rates",
    requiredRoles: [Role.AGENT_ADMIN],
  },
  {
    path: "/clients_monthly_adjustments",
    label: "Доп. начисления",
    componentPath: "ClientsMonthlyAdjustments",
    requiredRoles: [Role.AGENT_ADMIN],
    requiredProviders: [Provider.BELARUS],
  },
  {
    path: "/mydata",
    label: "Мои данные",
    componentPath: "MyData",
    requiredRoles: [
      Role.AGENT_ADMIN,
      Role.SALES,
      Role.SIGN,
      Role.RESET_PASSWORD,
      Role.AGENT,
    ],
    children: [
      {
        path: "/change_password",
        label: "Изменить пароль",
        componentPath: "ChangePasswordPage",
        requiredRoles: [
          "user",
          Role.AGENT_ADMIN,
          Role.RESET_PASSWORD,
          Role.AGENT,
        ],
      },
    ],
  },
  {
    path: "/detailing",
    label: "Детализация",
    componentPath: "Detailing",
    requiredRoles: [Role.AGENT_ADMIN, Role.SALES, Role.AGENT],
  },
  {
    path: "/leads",
    label: "Мои лиды",
    componentPath: "MyLeads",
    requiredRoles: [Role.AGENT_ADMIN, Role.AGENT],
  },
  {
    path: "/s2s",
    label: "Схема Сотрудник-Сотрудник",
    requiredRoles: [Role.SALES],
    children: [
      {
        path: "/s2s/create",
        label: "Подключение",
        componentPath: "S2S",
        requiredRoles: [Role.SALES],
      },
      {
        path: "/s2s/manage",
        label: "Управление",
        componentPath: "S2SManage",
        requiredRoles: [Role.SALES],
      },
      {
        path: "/s2s/conformation",
        label: "Подтверждение",
        componentPath: "S2SConformation",
        requiredRoles: [Role.SALES],
      },
    ],
  },
  {
    path: "/my_links",
    label: "Мои ссылки",
    componentPath: "Links",
    requiredRoles: [Role.AGENT_ADMIN, Role.AGENT],
  },
  {
    path: "/documents",
    label: "Документы",
    componentPath: "Documents",
    requiredRoles: [Role.AGENT_ADMIN, Role.SIGN, Role.AGENT],
  },
  // {
  //   path: "/training",
  //   label: "Обучение",
  //   componentPath: "Training",
  //   requiredRoles: [Role.AGENT_ADMIN, Role.SALES, Role.AGENT],
  // },
];

export default routesConfig;
